// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"767be310","195":"c6fece80","419":"26af06f9","563":"f5f403c1","787":"9ed1fd6b","852":"91e7f6d3","942":"9ce1ba1a"}[chunkId] + ".chunk.js";
};